import Reveal from '@/components/base/Reveal';

function WaitTrade() {
  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-16 md:py-28">
      <div className="max-w-[1200px] mx-auto">
        <Reveal>
          <p className="text-center text-[11px] font-data tracking-[0.24em] text-foreground-400 mb-14">
            TWO POSSIBLE STATES OF THE SYSTEM
          </p>
        </Reveal>

        <div className="relative flex flex-col md:flex-row items-center justify-center gap-10 md:gap-0">
          {/* WAIT */}
          <Reveal className="md:flex-1 flex justify-center md:justify-end md:pr-16">
            <div className="text-center">
              <p className="font-heading font-extrabold tracking-[0.035em] text-foreground-950 text-[56px] sm:text-[76px] lg:text-[92px] leading-none breathe">
                WAIT
              </p>
              <p className="mt-4 text-[14px] text-foreground-600">No setup. No trade.</p>
            </div>
          </Reveal>

          {/* connector — toggle switch */}
          <div className="relative flex items-center justify-center w-full py-6 md:py-0 md:w-36 md:h-24">
            {/* desktop track */}
            <span className="hidden md:block absolute left-0 right-0 top-1/2 h-px bg-gradient-to-r from-background-300 via-primary-300 to-primary-400"></span>
            {/* mobile track */}
            <span className="md:hidden absolute top-0 bottom-0 left-1/2 w-px bg-gradient-to-b from-background-300 via-primary-300 to-primary-400"></span>

            {/* flowing signal */}
            <span className="hidden md:block absolute top-1/2 h-1.5 w-1.5 rounded-full bg-primary-500 flow-x"></span>
            <span className="md:hidden absolute left-1/2 h-1.5 w-1.5 rounded-full bg-primary-500 flow-y"></span>

            {/* toggle switch */}
            <span className="relative z-10 flex items-center w-14 h-8 rounded-full border border-primary-400 bg-primary-100/70 p-1">
              <span className="absolute inset-0 rounded-full bg-primary-400/40 blur-[6px] toggle-halo"></span>
              <span className="relative w-6 h-6 rounded-full bg-primary-600 toggle-knob"></span>
            </span>
          </div>

          {/* TRADE */}
          <Reveal delay={140} className="md:flex-1 flex justify-center md:justify-start md:pl-16">
            <div className="text-center">
              <p className="font-heading font-extrabold tracking-[-0.02em] text-primary-600 text-[56px] sm:text-[76px] lg:text-[92px] leading-none">
                TRADE
              </p>
              <p className="mt-4 text-[14px] text-foreground-600">Conditions aligned.</p>
            </div>
          </Reveal>
        </div>

        <Reveal delay={200}>
          <div className="mt-10 md:mt-14 mx-auto max-w-[560px] rounded-lg border border-background-200 bg-background-100 px-6 py-5 text-center">
            <p className="text-[13px] md:text-sm text-foreground-500 leading-relaxed">
              Waiting is part of how the system works. When the predefined conditions are not met,
              the EA stays flat and continues evaluating the market.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export default WaitTrade;